module.exports = __webpack_public_path__ + "img/food_01.059c9838.jpg";